import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { FDDisplayText } from '@facet-wealth/design';
import {
  GoalStrategyDetailsSections,
} from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedTheYearAheadGoalStrategiesDetailsStep/Content/Sections/GoalStrategyDetailsSections';

const GoalStrategiesDetailsMetaOverride = buildFacetDesignOverride()
  .nameOverride(['title'], {
    _component: () => FDDisplayText,
    _customProps: { color: 'textSecondary', align: 'center' },
  }, overrideReadOnly)
  .nameOverride(['subtitle'], {
    _component: () => FDDisplayText,
    _customProps: { size: 'sm', align: 'center' },
  }, overrideReadOnly)
  .nameOverride('sections', {
    _component: () => GoalStrategyDetailsSections,
  }, overrideReadOnly);

export default GoalStrategiesDetailsMetaOverride;
